(function () {
  angular
    .module('kareo.ui.shared.directives.product.k-product-picker-view.url-for', [])
    .factory('UrlForProductPicker', urlFor);

  function urlFor() {
    const SOLUTION_CENTER_PRODUCT_BASE_URL = '/solution-center-ui/#/product/';
    const PRODUCT_NAME_URL_MAPPING = {
      KAREO_EHR: 'clinical',
      KAREO_OFFICE: 'engage',
      PM: 'billing',
      RCM: 'managed_billing',
      KMB: 'managed_billing',
      KAREO_TELEHEALTH: 'kareo_telehealth',
    };

    function solutionCenterProduct(product) {
      return SOLUTION_CENTER_PRODUCT_BASE_URL + PRODUCT_NAME_URL_MAPPING[product];
    }

    return {
      solutionCenterProduct
    };
  }
})();
